import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    ButtonGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    IconButton,
    Grid2,
    FormGroup,
    Switch,
    Typography,
    Select,
    MenuItem,
    InputLabel,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { AddCircle, RemoveCircle, Save } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid, myTimestampToDate, propComparator } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { add_Cow, edit_Cow } from '../FirebaseUtils/dbCow';
import { differenceInCalendarMonths } from 'date-fns';
import { useAuth } from '../core/AuthProvider';
import { common_data_entry, advance_data_entry, other_data_entry, mother_data_entry, lifetime_data_entry, cow_race_sublist as cow_breed_sublist } from '../definitions/cow';
import { CustomParamButton, PresenceButton } from '../components/PresenceButton';
import { CowtypeButton } from '../components/CowtypeButton';
import { DialogMultiSelector } from '../components/AdvanceSelector';
import { get_Category_list } from '../FirebaseUtils/dbCategory';
import { useEvent } from '../context/eventContext';
import { CowmanButton, CowmanHeader, CowmanRow } from '../definitions/cowman';
import { get_Cowman_list } from '../FirebaseUtils/dbCowman';
import { globalstyles } from '../lib/definitions';
import { get_Property_list } from '../FirebaseUtils/dbProperty';
import { PropertyButton, PropertyHeader, PropertyRow } from '../definitions/property';
import { CategoryButton, CategoryHeader, CategoryRow } from '../definitions/category';


const newcow = {
    name: '',
    cow_type: 'black',
    birth: 0,
}


const section_list = [
    { id: 'simple', label: 'dettagli' },
    { id: 'advance', label: 'avanzate' },
]



export const CowDialog = forwardRef(({ getLastCatalogNumber, addFn, editFn }, ref) => {
    const { user } = useAuth()
    const { selEvent } = useEvent()
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newcow })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [showAdvance, setShowAdvance] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [searchParams, setSearchParams] = useSearchParams()


//    const mapdata_param_key_list = [...common_data_entry, ...lifetime_data_entry, ...mother_data_entry, ...advance_data_entry, ...other_data_entry, ...[{ id: 'id' }]].map((x) => (x.id))




    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newcow, is_present: true })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newcow, ...el }
                setCurElement(_el)
                initData(is_c, el.id)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            addFn(curElement)
        } else {
            editFn(curElement, index)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        } else {
            setCurElement(el => {
                let _el = { ...el }
                delete _el[name]
                return { ..._el }
            })
            setIsEdited(true)

        }
    }




    const get_cowmanlist = async () => {
        const res = await get_Cowman_list(selEvent.id)
        console.log("RES", res)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('name'))
    }


    const get_propertylist = async () => {
        const res = await get_Property_list(selEvent.id)
        console.log("RES", res)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('name'))
    }


    const get_categorylist = async () => {
        const res = await get_Category_list(selEvent.id)
        console.log("RES", res)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('category_number'))
    }

    const initData = async (is_current, s_id) => {

    }

    useEffect(() => {
        return () => {

        }

    }, [])

    const insertCatalogNumber = () => {
        const c = getLastCatalogNumber()
        onChangeHandler({ name: 'catalog_id', value: c + 1 })
    }

    const checkConditional = (param) => {
        if (param.conditional) {
            if (curElement[param.conditional.param] && curElement[param.conditional.param] >= param.conditional.min_value) {
                return true
            }
            return false
        } else {
            return true
        }
    }

    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    <i>Dati Soggetto:</i>  <b>{curElement.name}</b>
                    <ButtonGroup size="small">
                        {showAdvance ?
                            <Button color="secondary" variant={!showAdvance ? 'contained' : 'outlined'} onClick={() => setShowAdvance(false)}>passa a visualizzazione compatta </Button>
                            :
                            <Button color="secondary" variant={showAdvance ? 'contained' : 'outlined'} onClick={() => setShowAdvance(true)}>passa a visualizzazione estesa</Button>
                        }
                    </ButtonGroup>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ mb: 1 }}>
                            <FormLabel id="label" sx={{ mr: 1 }}>Tipo di Soggetto</FormLabel>
                            <CowtypeButton cow_type={curElement.cow_type} setValue={(v) => onChangeHandler({ name: 'cow_type', value: v })} />
                        </Box>
                        <Box sx={{ mb: 1 }}>
                            <FormLabel id="label" sx={{ mr: 1 }}>Presenza</FormLabel>
                            <PresenceButton is_present={curElement.is_present} togglePresence={(p) => onChangeHandler({ name: 'is_present', value: p })} showclean />
                        </Box>
                        <Box sx={{ mb: 1 }}>
                            <MyInput
                                id={'catalog_id'}
                                label={'numero catalogo'}
                                value={curElement.catalog_id || ''}
                                onChange={(ev) => onChangeHandler(ev.target)}
                                InputProps={{
                                    sx: { width: '50%' }
                                }}
                                btn={<Button variant={!curElement.catalog_id ? 'contained' : "outlined"} onClick={insertCatalogNumber}>ottieni numero catalogo</Button>}
                            />
                        </Box>
                        <Grid container sx={{ mt: 0.5, mb: 0.5 }}>
                            <Typography sx={{ ...globalstyles.value_label, mr: 1 }}>
                                Categoria
                            </Typography>
                            <DialogMultiSelector
                                sourceFn={get_categorylist}
                                element={curElement.category || {}}
                                searchparam_list={['category_name', 'category_description']}
                                changeFn={(val) => onChangeHandler({ name: 'category', value: val })}
                                label="Categoria"
                                valueOnButton
                                isWarning={!curElement.category}
                                warningLabel="categoria non definita"
                                idParam={'id'}
                                renderButton={(prop) => <CategoryButton {...prop} />}
                                renderRow={(prop) => <CategoryRow {...prop} />}
                                renderHeader={(prop) => <CategoryHeader {...prop} />}

                            />
                        </Grid>
                        <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
                            <InputLabel id="breed-radio-buttons-group-label">Razza</InputLabel>
                            <Select
                                name="breed"
                                value={curElement.breed}
                                onChange={(ev) => onChangeHandler(ev.target, -1)}
                            >
                                <MenuItem value="">
                                    <em>...seleziona razza</em>
                                </MenuItem>
                                {cow_breed_sublist.map((e, k) => (
                                    <MenuItem value={e.id}>{e.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {common_data_entry.map((p, pk) => {
                            if (checkConditional(p))
                                return (
                                    <MyInput
                                        key={pk}
                                        id={p.id}
                                        label={p.label}
                                        type={p.type}
                                        min_value={p.min_value}
                                        value={curElement ? curElement[p.id] : ''}
                                        onChange={(ev) => onChangeHandler(ev.target)}
                                    />
                                )
                        }
                        )}
                    </Box>
                    <Grid container sx={{ mt: 0.5, mb: 0.5 }}>
                        <Typography sx={{ ...globalstyles.value_label, mr: 1 }}>
                            Proprietà (Azienda)
                        </Typography>
                        <DialogMultiSelector
                            sourceFn={get_propertylist}
                            element={curElement.property || {}}
                            searchparam_list={['cdaua', 'name']}
                            changeFn={(val) => onChangeHandler({ name: 'property', value: val })}
                            label="Proprietà"
                            valueOnButton
                            isWarning={!curElement.property || !curElement.property.id}
                            warningLabel="Proprietà non impostata"
                            idParam={'id'}
                            renderButton={(prop) => <PropertyButton {...prop} />}
                            renderRow={(prop) => <PropertyRow {...prop} />}
                            renderHeader={(prop) => <PropertyHeader {...prop} />}

                        />
                    </Grid>
                    <Grid container sx={{ mt: 0.5, mb: 0.5 }}>
                        <Typography sx={{ ...globalstyles.value_label, mr: 1 }}>
                            Allevatore (azienda di nascita)
                        </Typography>
                        <DialogMultiSelector
                            sourceFn={get_cowmanlist}
                            element={curElement.cowman || {}}
                            searchparam_list={['cdaua_cowman', 'name']}
                            changeFn={(val) => onChangeHandler({ name: 'cowman', value: val })}
                            label="Allevatore"
                            valueOnButton
                            isWarning={!curElement.cowman || !curElement.cowman.id}
                            warningLabel="allevatore non impostato"
                            idParam={'id'}
                            renderButton={(prop) => <CowmanButton {...prop} />}
                            renderRow={(prop) => <CowmanRow {...prop} />}
                            renderHeader={(prop) => <CowmanHeader {...prop} />}

                        />
                    </Grid>
                    {selEvent.custom_cow_filter_param_list?.map((cp,kcp) => (
                        <Box sx={{ mb: 1 }} key={kcp}>
                            <FormLabel id="label" sx={{ mr: 1 }}>{cp.param_name}</FormLabel>
                    <CustomParamButton  param_value={curElement[cp.param_name]} toggleParam={(v) => onChangeHandler({param: cp.param_name, value:v})} label={"si"}/>
                        </Box>
                    ))}
                    <Box sx={{ width: '100%' }}>
                        {showAdvance &&
                            <>
                                {advance_data_entry.map((p, pk) => (
                                    <MyInput
                                        key={pk}
                                        id={p.id}
                                        label={p.label}
                                        type={p.type}
                                        min_value={p.min_value}
                                        value={curElement ? curElement[p.id] : ''}
                                        onChange={(ev) => onChangeHandler(ev.target)}
                                    />
                                ))}
                                <Box sx={globalstyles.list_container}>
                                    <Typography sx={globalstyles.sectionHeader}>
                                        Lifetime
                                    </Typography>

                                    {lifetime_data_entry.map((p, pk) => (
                                        <MyInput
                                            key={pk}
                                            id={p.id}
                                            label={p.label}
                                            type={p.type}
                                            min_value={p.min_value}
                                            value={curElement ? curElement[p.id] : ''}
                                            onChange={(ev) => onChangeHandler(ev.target)}
                                        />
                                    ))}
                                </Box>
                                <Box sx={globalstyles.list_container}>
                                    <Typography sx={globalstyles.sectionHeader}>
                                        Dati madre
                                    </Typography>
                                    {mother_data_entry.map((p, pk) => (
                                        <MyInput
                                            key={pk}
                                            id={p.id}
                                            label={p.label}
                                            type={p.type}
                                            min_value={p.min_value}
                                            value={curElement ? curElement[p.id] : ''}
                                            onChange={(ev) => onChangeHandler(ev.target)}
                                        />
                                    ))}
                                </Box>
                                {/*                                 {Object.entries(curElement).filter(e => !mapdata_param_key_list.includes(e[0])).map((p, pk) => (
                                    <MyInput
                                        key={pk}
                                        id={p[0]}
                                        label={p[0]}
                                        value={curElement ? curElement[p[0]] : ''}
                                        onChange={(ev) => onChangeHandler(ev.target)}
                                    />
                                ))} */}
                            </>}
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})


const margin_top = 0.8

const MyInput = ({ type, label, id, value, onChange, min_value, btn }) => {
    const incrementValue = (param, param_global) => {
        onChange({ target: { value: parseInt(value) + 1, name: id } })

    }
    const decrementValue = (param, param_global) => {
        onChange({ target: { value: parseInt(value) - 1, name: id } })
    }
    if (type === 'date') {
        const v = myTimestampToDate(value)
        const diff = value ? differenceInCalendarMonths(new Date(), v) + ' mesi' : ''
        return (
            <Grid2 container sx={{ alignItems: 'center', mt: margin_top }}>
                <Grid2 xs={6}>
                    <DatePicker
                        variant="outlined"
                        size="small"
                        label={label} name={id} id={id}
                        value={v}
                        slotProps={{ field: { size: 'small' } }}
                        onChange={(nv) => onChange({ target: { value: nv, name: id } })} />
                </Grid2>
                <Grid2 xs={6} sx={{ ml: 1 }}>
                    {diff}
                </Grid2>
            </Grid2>
        )
    } else if (type === 'number') {
        console.log(min_value)
        return (

            <Box sx={{ mt: 0 }}>

                <TextField
                    margin="dense"
                    id={id}
                    label={label}
                    name={id}
                    variant="outlined"
                    value={value}
                    size="small"
                    onChange={(ev) => onChange(ev)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" color="primary" onClick={() => incrementValue(id)}>
                                    <AddCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconButton disabled={parseInt(value) <= min_value} edge="start" color="primary" onClick={() => decrementValue(id)}>
                                    <RemoveCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        )

    } else {
        return (
            <TextField
                size="small"
                sx={{ mt: margin_top }}
                id={id}
                label={label}
                fullWidth
                name={id}
                variant="outlined"
                value={value}
                onChange={onChange}
                InputProps={btn && {
                    endAdornment: (btn)
                }}
            />
        )

    }
}

